import React, { Component } from "react";
import { HashRouter, Route } from "react-router-dom";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import "typeface-roboto";

import Startup from "./pages/startup";
import Login from "./pages/login";
import Privacy from "./pages/privacy"
import Projects from "./pages/projects";
import Messages from "./pages/messages";
import Clients from "./pages/clients";
import Workorders from "./pages/workorders";
import Workorder from "./pages/workorder";
import WorkordersAdmin from "./pages/workordersadmin";
import Users from "./pages/users";
import Accounting from "./pages/accounting";
import Visma from "./pages/visma";
import Info from "./pages/info";
import Calendar from "./pages/calendar";
import SettingsApp from "./pages/settingsapp";

import Snackbar from "@material-ui/core/Snackbar";

import MenuLayout from "./components/layout/menulayout";

import UserService from "./services/users";

const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      light:"rgba(178,5,3,1)", // "rgba(17,40,84,1)",  rgba(178,5,3,1)
      main:"rgba(178,5,3,1)",//rgba(181,91,87,1
      dark: "rgba(178,5,3,1)",
      contrastText: "#fff"
    },
    secondary: {
      light: "rgba(213,35,29,1)",//"rgba(117,117,117,1)",
      main: "rgba(213,35,29,1)",
      dark: "rgba(213,35,29,1)",
      contrastText: "#FFF"
    },
    error: {
      light: "rgba(178,5,3,1)",
      main:"rgba(178,5,3,1)",
      dark:"rgba(178,5,3,1)",
      contrastText: "#fff"
    }
  }
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { message: {}, showMessage: false, menu: {} };
  }

  //Error message
  handleMessage = message => {
    this.setState({ message });
    this.setState({ showMessage: true });
  };

  handleClose = () => {
    this.setState({ showMessage: false });
  };

  //Menu layout
  handleMenu = (value) => {
    this.setState({ menu: value });

  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left"
          }}
          open={this.state.showMessage}
          autoHideDuration={6000}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          message={<span id="message-id">{this.state.message.title}</span>}
        />

        <MenuLayout menu={this.state.menu}
         
          menuitems={UserService.currentUser()&&UserService.currentUser().menuitems}
          handleNewFunction={this.state.menu.newItemFunction}
          handleActions={this.state.menu.handleActions}
          {...this.props}
        >

          <HashRouter path={"/"} Component={Startup}>
            <div style={{ width: "100%"}}>
              <Route path={"/"} exact render={props => <Startup {...props} />} />
              <Route
                path="/login"
                exact
                render={props => (
                  <Login
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/privacy"
                exact
                render={props => (
                  <Privacy
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
             
                <Route
                path="/info"
                exact
                render={props => (
                  <Info
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
              <Route
                path="/workorders"
                exact
                render={props => (
                  <Workorders
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
              <Route
                path="/workorders/:id"
                exact
                render={props => (
                  <Workorder
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/workordersadmin"
                exact
                render={props => (
                  <WorkordersAdmin
                    {...props}
                    isAdmin={true}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
              <Route
                path="/workordersadmin/:id"
                exact
                render={props => (
                  <Workorder
                    {...props}
                    isAdmin={true}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
              <Route
                path="/users"
                exact
                render={props => (
                  <Users
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/users/:id"
                exact
                render={props => (
                  <Users
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
              <Route
                path="/clients"
                exact
                render={props => (
                  <Clients
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/clients/:id"
                exact
                render={props => (
                  <Clients
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
              <Route
                path="/projects"
                exact
                render={props => (
                  <Projects
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/projects/:id"
                exact
                render={props => (
                  <Projects
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
                 <Route
                path="/messages"
                exact
                render={props => (
                  <Messages
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/messages/:id"
                exact
                render={props => (
                  <Messages
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/accounting"
                exact
                render={props => (
                  <Accounting
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/accounting/:id"
                exact
                render={props => (
                  <Accounting
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
                <Route
                path="/calendar"
                exact
                render={props => (
                  <Calendar
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/calendar/:id"
                exact
                render={props => (
                  <Calendar
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/visma"
                exact
                render={props => (
                  <Visma
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
               <Route
                path="/settings"
                exact
                render={props => (
                  <SettingsApp
                    {...props}
                    handleMessage={this.handleMessage}
                    handleMenu={this.handleMenu}
                  />
                )}
              />
            </div>
          </HashRouter>
        </MenuLayout>
      </MuiThemeProvider>
    );
  }
}

export default App;
